import { takeLatest, call, put } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import { ActivityAction, InitAction } from "../actions";
import { createBrowserHistory } from "history";
import moment from "jalali-moment";
import queryString from "query-string";
import * as activityApi from "../api/activity";
import { toastr } from "react-redux-toastr";
import { goBack } from "connected-react-router";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";
moment.locale("fa");

export function* watcherActivity() {
  yield takeLatest(types.GET_ACTIVITY_REQUEST, get);
  yield takeLatest(types.API_CALL_ACTIVITY_REQUEST, worker);
  yield takeLatest(types.GET_DAILY_ACTIVITY_REQUEST, dailyActivityWorker);
  yield takeLatest(types.GET_MONTHLY_ACTIVITY_REQUEST, monthlyActivityWorker);
  yield takeLatest(types.STORE_ACTIVITY_REQUEST, storeActivityWorker);
  yield takeLatest(types.API_REMOVE_ACTIVITY_REQUEST, removeActivityWorker);
}

function* get(action) {
  try {
    const response = yield call(getRequest, action.id);
    yield put(ActivityAction.getSuccess(response.data.data));
  } catch (error) {
    yield put(ActivityAction.getFailure());
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
  }
}
function getRequest(id) {
  return activityApi.get(id);
}

async function fetchList(data, pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  const history = createBrowserHistory();
  let urlFilters = await queryString.parse(document.location.search);
  let parsed = { ...urlFilters };
  if (urlFilters.date_type !== undefined) {
    switch (parseInt(urlFilters.date_type)) {
      case 1:
        parsed.start_date = moment()
          .subtract(1, "months")
          .local("fa")
          .format("YYYY/MM/DD");
        parsed.end_date = moment()
          .local("fa")
          .format("YYYY/MM/DD");
        break;
      case 2:
        parsed.start_date = moment()
          .local("fa")
          .format("YYYY/MM/DD");
        parsed.end_date = moment()
          .local("fa")
          .format("YYYY/MM/DD");
        break;
      default:
        parsed.start_date = urlFilters.start_date;
        parsed.end_date = urlFilters.end_date;
    }
  }
  parsed.start_date = parsed.start_date.split("/").join("-");
  parsed.end_date = parsed.end_date.split("/").join("-");
  const search = await queryString.stringify(parsed);
  const oldSearch = history.location.search.substring(
    1,
    history.location.search.length
  );
  if (history.location.search !== "" && oldSearch !== search) {
    history.push({ search: `?${search}` });
  }
  let type = 0;
  if (parsed.activity_detail_type !== undefined) {
    type = parsed.activity_detail_type;
    if (parsed.activity_detail_type === "1-2-3-29") {
      type = 0;
    }
  }
  let sort_field = parsed.sort_field || data.sort_field;
  let sort_type = parsed.sort_type || data.sort_type;
  if (parsed.sort_field !== undefined && parsed.sort_field === "date") {
    sort_field = "start_date";
    sort_type = "asc";
  }
  urlFilters = {
    ...urlFilters,
    start_date: parsed.start_date.split("-").join("/"),
    end_date: parsed.end_date.split("-").join("/"),
    contact_list:
      urlFilters.contact_list !== undefined
        ? [urlFilters.contact_list]
        : [data.contact_list],
    user_list:
        urlFilters.user_list !== undefined
            ? [urlFilters.user_list]
            : data.user_list,
    type: type,
    sort_field,
    sort_type
  };
  if (urlFilters.contact_list !== undefined) {
    if (parseInt(urlFilters.contact_list) === 0) {
      urlFilters.contact_list = [];
    }
    if (
      isNaN(urlFilters.contact_list) &&
      urlFilters.contact_list &&
      urlFilters.contact_list.toString() === "_1"
    ) {
      urlFilters.contact_list = [-1];
    }
  }
  if (urlFilters.user_list !== undefined) {
    if (parseInt(urlFilters.user_list) === 0) {
      urlFilters.user_list = [];
    }
  }
  const finalFilter = { ...data, ...urlFilters };

  return activityApi.getListActivityDetail(page_number, finalFilter);
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.data, action.pageNumber);
    yield put(ActivityAction.getAllSuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(ActivityAction.getAllFailure(error));
  }
}

function fetchDailyActivityList(data) {
  return activityApi.getListDailyActivity(data);
}

function fetchMonthlyActivityList(data) {
  return activityApi.getListMonthlyActivity(data);
}

function* dailyActivityWorker(action) {
  try {
    const response = yield call(fetchDailyActivityList, action.data);
    yield put(ActivityAction.getDailySuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(ActivityAction.getDailyFailure(error));
  }
}

function* monthlyActivityWorker(action) {
  try {
    const response = yield call(fetchMonthlyActivityList, action.data);
    yield put(ActivityAction.getMonthlySuccess(response.data));
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(ActivityAction.getMonthlyFailure(error));
  }
}

function storeActivity(data) {
  return activityApi.store(data);
}

function* storeActivityWorker(action) {
  try {
    const response = yield call(storeActivity, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(
      ActivityAction.storeSuccess(
        response.data,
        parseInt(action.data.delete_list.toString())
      )
    );
    yield put(InitAction.getSuccess({ premium: response.data.premium }));
    if (action.getActivityListData) {
      if (action.getActivityListData.activityDetail) {
        yield put(ActivityAction.getAll(action.getActivityListData.data));
      }
      if (
        action.getActivityListData.type === 2 ||
        action.getActivityListData.type === 1
      ) {
        yield put(ActivityAction.getDaily(action.getActivityListData));
      }
      if (action.getActivityListData.year !== undefined) {
        yield put(ActivityAction.getMonthly(action.getActivityListData));
      }
    }
    if (action.getActivity) {
      if (
        action.data.update_list &&
        action.data.update_list[0] &&
        action.data.update_list[0].id
      )
        yield put(ActivityAction.getRequest(action.data.update_list[0].id));
    }
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(
      ActivityAction.storeFailure(
        error.response.data,
        parseInt(action.data.delete_list.toString())
      )
    );
  }
}

function* removeActivityWorker(action) {
  try {
    const response = yield call(storeActivity, action.payLoad.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ActivityAction.storeSuccess(response.data));
    if (action.payLoad.goBack) {
      yield put(goBack());
    }
  } catch (error) {
    checkErrorMessagesExist(error) &&
      error.response.data.message.forEach(message => {
        toastr.error(" ", message.toString());
      });
    yield put(ActivityAction.removeFailure(error.response.data));
  }
}
